/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SearchRequestSchemaSortBy = typeof SearchRequestSchemaSortBy[keyof typeof SearchRequestSchemaSortBy];


export const SearchRequestSchemaSortBy = {
  relevance: 'relevance',
  recent: 'recent',
  experience: 'experience',
  shuffled: 'shuffled',
  'ranked-shuffle': 'ranked-shuffle',
} as const;
